import * as _ from 'underscore';

export module QueryParameterHelper {
  export function urlWithParams(url: string, params: any): string {
    const pairs = _.map(params, (value: string, key: string) => {
      return encodeUriQuery(key, true) + '=' + encodeUriQuery(value, true);
    });
    if (pairs.length > 0) {
      const urlFragments = url.split('#');
      const separator = (urlFragments[urlFragments.length-1].indexOf('?') >= 0) ? '&' : '?';
      const paramsString = pairs.join('&');
      return url + separator + paramsString;
    } else {
      return url;
    }
  }
}

// This is copied from angular.js. Location.search uses this function instead of just encodeURIComponent which was
// causing extra entries in the history and preventing a user from using back properly- TFSID
function encodeUriQuery(val: string, pctEncodeSpaces?: boolean) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

export function encodeUriQueryExceptForSlashes(val: string) {
  return encodeUriQuery(val, true).
             replace(/%2F/gi, '/');
}

export function encodeSpecialSlash(url: string, replacer: string) {
  return url.replace(/%2F/g, replacer);
}
export function decodeSpecialSlash(url: string, replacer: string) {
  return url.replace(new RegExp(replacer, 'g'), '%2F');
}

export function getReplacerForUserSlashKeep(url: string) {
  // No encoded slash? Then we're good.
  if (!url.match(/%2f/i)) {
    return null;
  }

  // Come up with a new string to temporarily encode the encoded slash '%2F'.
  // Make sure that string doesn't already exist in the URL.
   for (;;) {
     // String to replace encoded slash is:
     // Random float 0<=x<1
     // Converted to base36 [a-z0-9] string
     // Padded with 9 zeros (9 because if random is 0, total string lenght of 10 is needed for next step)
     // Cut off first digit and decimal point and get the next 8 characters
     // Enquoted within '='
    var slashReplacer = '=' + (Math.random().toString(36) + '000000000').slice(2,10) + '=';
    if (!url.includes(slashReplacer) &&
        // Handle edge cases by ensuring that if we encode and decode the url, there is no change to the url
        decodeSpecialSlash(encodeSpecialSlash(url, slashReplacer), slashReplacer) === url) {
      return slashReplacer;
    }
    // The URL already has that string. Try again until there's no match.
  }
}
